module.exports = __webpack_public_path__ + "static/media/ent-image3@2x.d4788f59.png";